import counterService from "src/services/counterService";

export const SEARCH_COUNTERS_REQUEST = "@variant/search-counters-request";
export const SEARCH_COUNTERS_SUCCESS = "@variant/search-counters-success";
export const SEARCH_COUNTERS_FAILURE = "@variant/search-counters-failure";

export const ADD_COUNTER_REQUEST = "@variant/add-counter-request";
export const ADD_COUNTER_SUCCESS = "@variant/add-counter-success";
export const ADD_COUNTER_FAILURE = "@variant/add-counter-failure";

export const UPDATE_COUNTER_REQUEST = "@variant/update-counter-request";
export const UPDATE_COUNTER_SUCCESS = "@variant/update-counter-success";
export const UPDATE_COUNTER_FAILURE = "@variant/update-counter-failure";

export function searchCounters(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: SEARCH_COUNTERS_REQUEST});
      const response = await counterService.searchCounters(data);
      dispatch({
        type: SEARCH_COUNTERS_SUCCESS,
        payload: {
          response: response.data,
          total: response.total_items
        }
      });
    } catch (error) {
      dispatch({type: SEARCH_COUNTERS_FAILURE});
      throw error;
    }
  };
}

export function addCounterToStation(data) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_COUNTER_REQUEST});
      const response = await counterService.addCounterToStation(data);
      dispatch({
        type: ADD_COUNTER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: ADD_COUNTER_FAILURE});
      throw error;
    }
  };
}

export function updateCounter(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_COUNTER_REQUEST});
      const response = await counterService.updateCounter(data);
      dispatch({
        type: UPDATE_COUNTER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_COUNTER_FAILURE});
      throw error;
    }
  };
}
